import getters from './getters'
import actions from './actions'
import mutations from './mutations'
const state = {
    serviceRequestChalan: {
        isInward: false,
        chalanItems: [
            {
                name: "",
                quantity: 1,
            },
        ]
    },
    serviceRequestChalansList: [],
    allChalans: [],
    chalanMeta : {},

}
const serviceRequestChalan = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default serviceRequestChalan;